<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/5 w-full">
      <span>Label</span>
    </div>
    <div class="vx-col sm:w-3/5 w-full">
      <vs-select v-model="label">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in labels"
        />
      </vs-select>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      label: "",
    };
  },
  methods: {
    render() {
      return {
        label: this.label,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      labels: "guestSegmentation/labels",
    }),
  },
  async mounted() {
    await this.$store.dispatch("guestSegmentation/get", false);
    if (this.action) {
      this.label = this.action.label;
    }
  },
};
</script>

<style lang="scss">
</style>